import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class StandardCapitalGainError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('StandardCapitalGainError', ...args);
    }
}
export default StandardCapitalGainError;
